module.exports = __webpack_public_path__ + "static/media/quiz-background1.b36f3d34.png";